import { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";

const LazyImage = ({ src, alt, className, style, animate, transition, ...props }) => {
  const [loaded, setLoaded] = useState(false);
  const [inView, setInView] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  if (animate || transition) {
    return (
      <div ref={ref} className="relative" style={{ minHeight: inView ? undefined : 100 }}>
        {!loaded && inView && (
          <div className="absolute inset-0 bg-[#111827] animate-pulse rounded" />
        )}
        {inView && (
          <motion.img
            src={src}
            alt={alt || ""}
            className={className}
            style={{ ...style, opacity: loaded ? 1 : 0, transition: "opacity 0.4s" }}
            onLoad={() => setLoaded(true)}
            loading="lazy"
            animate={animate}
            transition={transition}
            {...props}
          />
        )}
      </div>
    );
  }

  return (
    <div ref={ref} className="relative" style={{ minHeight: inView ? undefined : 100 }}>
      {!loaded && inView && (
        <div className="absolute inset-0 bg-[#111827] animate-pulse rounded" />
      )}
      {inView && (
        <img
          src={src}
          alt={alt || ""}
          className={className}
          style={{ ...style, opacity: loaded ? 1 : 0, transition: "opacity 0.4s" }}
          onLoad={() => setLoaded(true)}
          loading="lazy"
          {...props}
        />
      )}
    </div>
  );
};

export default LazyImage;
